import * as moment from 'moment/moment';

export class DealerComment {

  readonly comments: string;

  readonly creatorName: string;

  readonly dateAdded: Date;

  readonly id: number;

  static fromJSON(jsonObject: any): DealerComment {
    const result = Object.create(DealerComment.prototype);
    return Object.assign(result, jsonObject, {
      dateAdded: jsonObject.dateAdded ? moment(jsonObject.dateAdded).toDate() : null
    });
  }

}
